const { Keywords } = require('../core/keywords');

/**
 * Supported Escape Characters:
 * \n - Newline
 * \t - Tab
 * \r - Carriage Return
 * \" - Double Quote
 * \' - Single Quote
 * \\ - Backslash
 */

module.exports = {
    [Keywords.PROGRAM_START]: 'hallo {{name}}',
    [Keywords.PROGRAM_END]: 'tschüss {{name}}',
    [Keywords.PRINT]: 'sag es {{name}}',
    [Keywords.VARIABLE]: '{{name}} das ist',
    [Keywords.UNTIL]: 'bis {{name}}',
    [Keywords.IF]: 'wenn {{name}}',
    [Keywords.ELSE]: 'andernfalls {{name}}',
    [Keywords.FOR]: 'schleife {{name}}',
    [Keywords.BREAK]: 'brich',
    [Keywords.CONTINUE]: 'weiter',
    [Keywords.TRUE]: 'wahr',
    [Keywords.FALSE]: 'falsch',
    [Keywords.AND]: 'und',
    [Keywords.OR]: 'oder',
    [Keywords.LENGTH]: 'länge',
    [Keywords.INPUT]: 'frage {{name}}'
};
